import { Toaster } from 'sonner';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { appConfig } from "../apiConfig";
import { useLanguage } from "../context/LanguageProvider";

export default function AuthLayout() {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `${appConfig.name} | ${t('layout.auth.page_title')}`;
    
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = `/images/${appConfig.slug}-fav.png`;
    }
  }, []);

  return (
    <div className="min-h-screen  flex flex-col justify-center font-cairo">
      <Toaster richColors />
      <div className="">
         <Outlet />
      </div>
    </div>
  );
}
